module.exports = __webpack_public_path__ + "static/media/fish.444d46c9.ogg";